/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../../components/UI'
import {FC, useEffect, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../../_metronic/helpers'
import {OptionByProfileModel} from '../../../../../model'
import {getOptionsByProfile, deleteOptionsByProfile} from '../../../../../services'
import {useCentral} from '../../../../../../../hooks/useCentral'
import {ModalAddOptions} from '../modal/ModalAddOptions'
import Swal from 'sweetalert2'
import {ShowSnackBar} from '../../../../../../../util/functions'
const TablePermissionByProfile: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination, selectedOn, clearSelected} =
    useKTable()
  const {currentTabItem, isAllowed} = useCentral()
  const [showModalNew, setShowModalNew] = useState(false)
  const [idPermission, setIdPermission] = useState<any>('')
  const [detailpermission, setDetailPermission] = useState<OptionByProfileModel | any>(null)

  const getOptionsByProfileList = async () => {
    try {
      clearSelected()
      setLoading(true)
      const {data: response} = await getOptionsByProfile(
        pagination.currentPage,
        currentTabItem.idToEdit,
      )
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleClear = () => {
    setIdPermission('')
  }
  const handleEdit = (item: OptionByProfileModel) => {
    const filter = data.filter((detail) => detail.id === item.id)
    setDetailPermission(filter[0])
    setIdPermission(item.id)
    setShowModalNew(true)
  }
  useEffect(() => {
    getOptionsByProfileList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    getOptionsByProfileList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  const columns: Column<OptionByProfileModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCellNonMultiple id={props.data[props.row.index].id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Opción' />,
      accessor: 'vistaPermiso',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('PERMISO/EDITAR') && (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEdit(props.data[props.row.index])}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          )}
        </>
      ),
    },
  ]

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        const filter = data.filter((detail) => detail.id === selectedOn[0])
        let obj = {
          perfilId: currentTabItem.idToEdit,
          vistaPermisoId: filter[0]?.vistaPermisoId,
        }
        const {data: response} = await deleteOptionsByProfile(obj)
        if (!response.error) {
          ShowSnackBar('Se eliminó satisfactoriamente')
          getOptionsByProfileList()
        } else {
          ShowSnackBar(response.message, 'error')
        }
        getOptionsByProfileList()
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleNew = () => {
    setShowModalNew(true)
  }

  return (
    <>
      {isAllowed('PERMISO/LISTAR') && (
        <KTCard shadow className='m-5'>
          <div className='d-flex justify-content-end p-2 me-5'>
            {isAllowed('PERMISO/AGREGAR') && (
              <button type='button' className='btn btn-success me-3' onClick={handleNew}>
                Agregar
              </button>
            )}
            {isAllowed('PERMISO/ELIMINAR') && (
              <button
                type='button'
                className='btn btn-primary me-3'
                disabled={selectedOn.length < 1}
                onClick={handleDelete}
              >
                Eliminar
              </button>
            )}
          </div>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          {loading ? <KTableLoading title='Cargando...' /> : null}
          <ModalAddOptions
            show={showModalNew}
            setShow={setShowModalNew}
            getOptionsByProfileList={getOptionsByProfileList}
            detailpermission={detailpermission}
            idPermission={idPermission}
            setIdPermissionList={handleClear}
          />
        </KTCard>
      )}
    </>
  )
}

const TablePermissionByProfileWrapper = () => {
  return (
    <KTableProvider>
      <TablePermissionByProfile />
    </KTableProvider>
  )
}
export {TablePermissionByProfileWrapper}
